export interface AvailabilityChangeData {
  previousSeatedCount: number;
  previousWaitlistCount: number;
  newSeatedCount: number;
  newWaitlistCount: number;
}

export function computeAvailabilityChanges(
  selectedCount: number,
  previousAvailableSeats: number,
  newAvailableSeats: number,
): AvailabilityChangeData {
  return {
    previousSeatedCount: Math.min(selectedCount, previousAvailableSeats),
    previousWaitlistCount: Math.max(0, selectedCount - previousAvailableSeats),
    newSeatedCount: Math.min(selectedCount, newAvailableSeats),
    newWaitlistCount: Math.max(0, selectedCount - newAvailableSeats),
  };
}

export function buildAvailabilityChangeMessages(
  previousAvailableSeats: number,
  newAvailableSeats: number,
): { changes: string[]; message: string } {
  const changes: string[] = [];
  if (newAvailableSeats < previousAvailableSeats) {
    changes.push(
      `Available seats decreased from ${previousAvailableSeats} to ${newAvailableSeats}.`,
    );
  } else {
    changes.push(
      `Available seats increased from ${previousAvailableSeats} to ${newAvailableSeats}.`,
    );
  }

  return {
    changes,
    message: `Seat availability has changed. There are now ${newAvailableSeats} seats available (was ${previousAvailableSeats}).`,
  };
}
